
import { useNavigate } from 'react-router-dom';

// material-ui
import React, { useEffect , useMemo, useState } from 'react';

// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import Badge from '@mui/material/Badge';
import InputBase from '@mui/material/InputBase';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Crown from '../../../assets/images/users/crown';
import { keyframes } from '@mui/system';


// project imports
import AppBarStyled from './AppBarStyled';
import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';
import { DRAWER_WIDTH, MINI_DRAWER_WIDTH } from 'config';

// assets
import MenuFoldOutlined from '@ant-design/icons/MenuFoldOutlined';
import MenuUnfoldOutlined from '@ant-design/icons/MenuUnfoldOutlined';
import SearchOutlined from '@ant-design/icons/SearchOutlined';
import BellOutlined from '@ant-design/icons/BellOutlined';
import SettingOutlined from '@ant-design/icons/SettingOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import { bgcolor } from '@mui/system';
import { color } from 'framer-motion';
import Upgrade_popup from '../../../components/upgrade-accounts/upgrade_popup';
import BalanceButtonGroup from './HeaderContent/Profile/balanceButtonGroup';

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

export default function Header() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;
  const navigate = useNavigate();
const [dataloading , setdataloading] = useState(true);
const [profileUrl, setProfileUrl] = useState('https://via.placeholder.com/120');


  useEffect(() => {
  const timeout = setTimeout(() => {
    const token = localStorage.getItem('twitter_token');
    const TOKEN = localStorage.getItem("token");
    const API_BASE_URL = import.meta.env.VITE_API_URL || "https://socialmedia.gtlit.com";

    if (!token) return;

    fetch(`${API_BASE_URL}/get_image_details?token=${token}`, {
      method: "POST",
      headers: { 
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TOKEN}`,
      },
      body: JSON.stringify({ token }),
    })
      .then(res => res.json())
      .then(result => {
        if (result.status && result.data && result.data.profileUrl) {
          const fullUrl = "https://socialmedia.gtlit.com" + result.data.profileUrl;
          setProfileUrl(fullUrl); // <--- THIS TRIGGERS RE-RENDER
        }
      })
  }, 200);

  return () => clearTimeout(timeout);
}, []);

  // logout handler
  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  // ------------------ merged Search ------------------
  const SearchBar = () => (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        bgcolor: 'grey.100',
        px: 1.5,
        py: 0.5,
        borderRadius: 2,
        width: { xs: '100%', sm: 200, md: 250 }
      }}
    >
      <SearchOutlined style={{ fontSize: 18, marginRight: 8 }} />
      <InputBase placeholder="Search…" sx={{ flex: 1 }} />
    </Stack>
  );

  // ------------------ merged Notification ------------------
  const Notification = () => (
    <IconButton color="inherit">
      <Badge badgeContent={3} color="error">
        <BellOutlined />
      </Badge>
    </IconButton>
  );

  // ------------------ merged Settings ------------------
  const SettingTab = () => (
    <IconButton color="inherit">
      <SettingOutlined />
    </IconButton>
  );

  // ------------------ merged Profile ------------------
  const ProfileTab = () => {
    const [anchorEl, setAnchorEl] = useState(null);

    const open = Boolean(anchorEl);

    return (
      <>
        <IconButton onClick={(e) => setAnchorEl(e.currentTarget)} color="inherit">
                    <Avatar
            alt="User"
            src={profileUrl}
            sx={{ width: 36, height: 36, fontSize: 18 }}
          >
        <UserOutlined />
          </Avatar>
        </IconButton>
        <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
          <MenuItem onClick={() => navigate('/profile')}>Profile</MenuItem>
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </Menu>
      </>
    );
  };

  // ------------------ merged Mobile Menu ------------------
  const MobileSection = () => (
    <IconButton color="inherit" sx={{ display: { lg: 'none' } }}>
      {/* <MenuUnfoldOutlined /> */}
    </IconButton>
  );

  // ------------------Upgrade Button  -------------------------



const UpgradeButton = ({ sx }) => {
  const [open, setOpen] = useState(false);
  const [plansData, setPlansData] = useState(null); // store API data
  const [dataLoading, setDataLoading] = useState(true); // loader
  const userType = localStorage.getItem("userType");

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    const fetchPlansByUserType = async (jwt, userType) => {
      setDataLoading(true);
      try {
        const response = await fetch(
          `https://socialmedia.gtlit.com/api/get_plans_by_user_type?user_type=${userType}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${jwt}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) throw new Error(`Status ${response.status}`);

        const apiData = await response.json();
        console.log("Plans API Response:", apiData);

        setPlansData(apiData); // ✅ store full response
        //setTimeout(() => {
          //setOpen(true);
        //}, 2000);
      } catch (error) {
        console.error("Plans API call FAILED:", error);
        setPlansData(null);
      } finally {
        setDataLoading(false); // ✅ stop loading after fetch
      }
    };

    // Handle token from URL if present
    const params = new URLSearchParams(window.location.search);
    const tokenFromUrl = params.get("token");
    if (tokenFromUrl) {
      localStorage.setItem("token", tokenFromUrl);
      window.history.replaceState({}, document.title, window.location.pathname);
    }

    const jwt = localStorage.getItem("token");
    if (jwt && userType) {
      fetchPlansByUserType(jwt, userType);
    } else {
      setDataLoading(false);
    }
  }, [userType]);

  return (
    <>
              <Button
          color="inherit"
          onClick={handleOpen}
          endIcon={
            <Crown
              sx={{
                color: 'gold',
                position: 'relative',
                top: '-2px',
              }}
            />
          }
          sx={{
            bgcolor: '#272360',         // rich indigo/navy that contrasts with the background
            color: '#fff',           // soft gold text for premium feel
            textTransform: 'none',
            fontWeight: 500,
            fontSize: 16,
            px: 3,       // less horizontal padding on mobile
            py: 1,
            borderRadius: 3,
            border: '2px solid #3f379f', // subtle border for elegance
            boxShadow: '0 4px 16px rgba(40, 36, 94, 0.30)', // strong shadow, background-coordinated
            transition: 'background-color 0.25s, color 0.25s',
            '&:hover': {
              bgcolor: '#3f379f',
              color: '#ffd700',        // turn text to gold on hover
              boxShadow: '0 6px 24px rgba(40, 36, 94, 0.40)',
            },
            '& .MuiButton-endIcon': { ml: 1 },
            minWidth: 120,
            cursor: 'pointer',
            userSelect: 'none',
            ...sx,
          }}
        >
          Upgrade
        </Button>

      {/* Only show popup after data loaded */}
      {!dataLoading && plansData && (
        <Upgrade_popup open={open} onClose={handleClose} data={plansData} />
      )}
    </>
  );
};

      // ------------------ header content ------------------
      const headerContent= useMemo(
        () => (
          <Stack direction="row" spacing={2} alignItems="center" sx={{ ml: 'auto', color: '#fff' }}>
            {/* <SearchBar /> */}
            <BalanceButtonGroup />
            <UpgradeButton />
            {/* <Notification /> */}
            {/* <SettingTab /> */}
            <ProfileTab />
            <Button variant="outlined" color="error" onClick={handleLogout}>
              Logout
            </Button>
            <MobileSection />
          </Stack >
        ),
        [profileUrl]
      );

  // ------------------ main header ------------------
  const mainHeader = (
    <Toolbar>
      <IconButton
        aria-label="open drawer"
        onClick={() => handlerDrawerOpen(!drawerOpen)}
        edge="start"
        color="secondary"
        sx={(theme) => ({
          color: 'text.primary',
          bgcolor: drawerOpen ? 'transparent' : 'grey.100',
          ...theme.applyStyles('dark', { bgcolor: drawerOpen ? 'transparent' : 'background.default' }),
          ml: { xs: 0, lg: -2 }
        })}
      >
        {!drawerOpen ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
      </IconButton>
      {headerContent}
    </Toolbar>
  );

  // ------------------ app-bar params ------------------
  const appBar = {
    position: 'fixed',
    color: 'inherit',
    elevation: 0,
    sx: {
      borderBottom: '1px solid',
      borderBottomColor: 'divider',
      zIndex: 1200,
      width: { xs: '100%', lg: drawerOpen ? `calc(100% - ${DRAWER_WIDTH}px)` : `calc(100% - ${MINI_DRAWER_WIDTH}px)` },
      //background: '#040917',
background: '#fff'
    }
  };


  return (
<>
  {!downLG ? (
    <AppBarStyled open={drawerOpen} {...appBar} sx={{ borderRadius: '10px', borderTop:'7px solid #f4f1ff' }}>
      {mainHeader}
    </AppBarStyled>
  ) : (
    <AppBar {...appBar} sx={{ borderRadius: '10px', borderTop:'7px solid #f4f1ff' }}>
      {mainHeader}
    </AppBar>
  )}
</>
  );
}
